module.exports = __webpack_public_path__ + "img/Disclaimer.af29bccc.svg";